import { TemplateListItemDto } from "@modules/template/domain/template.dto";

const GLOBAL_EVENT = {
  CHOOSE_IMAGE: "CHOOSE_IMAGE",
  CHOOSE_TEMPLATE: "CHOOSE_TEMPLATE",
  AUTH: {
    FORCE_LOGOUT: "AUTH.FORCE_LOGOUT",
    VALIDATE_SESSION: "AUTH.VALIDATE_SESSION",
  },
} as const;

interface ChooseImageResponse {
  imgUrl?: string;
}

interface ChooseTemplateResponse extends TemplateListItemDto {}

export interface EventProps {
  [GLOBAL_EVENT.CHOOSE_IMAGE]: ChooseImageResponse;
  [GLOBAL_EVENT.CHOOSE_TEMPLATE]: ChooseTemplateResponse;
  [GLOBAL_EVENT.AUTH.VALIDATE_SESSION]: object;
}

export default GLOBAL_EVENT;
